/* eslint-disable react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../SVGWrapper';

function TvPlaylistActiveIcon({ height = 60, width = 60 }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 70 70"
      fill="none"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M35 67.8125C53.1218 67.8125 67.8125 53.1218 67.8125 35C67.8125 16.8782 53.1218 2.1875 35 2.1875C16.8782 2.1875 2.1875 16.8782 2.1875 35C2.1875 53.1218 16.8782 67.8125 35 67.8125ZM17.5 20.3397V28.5145C17.5 29.0089 18.0691 29.323 18.5356 29.0861L26.2265 25.1817C26.7021 24.9403 26.7152 24.3094 26.2499 24.051L18.5591 19.7806C18.0924 19.5214 17.5 19.8342 17.5 20.3397ZM52.5 24.9011C52.5 25.6864 51.9276 26.323 51.2216 26.323H31.5051C30.799 26.323 30.2266 25.6864 30.2266 24.9011C30.2266 24.1158 30.799 23.4792 31.5051 23.4792L51.2216 23.4792C51.9276 23.4792 52.5 24.1158 52.5 24.9011ZM51.1373 37.698C51.8434 37.698 52.4158 37.0614 52.4158 36.2761C52.4158 35.4908 51.8434 34.8542 51.1373 34.8542L18.7784 34.8542C18.0724 34.8542 17.5 35.4908 17.5 36.2761C17.5 37.0614 18.0724 37.698 18.7784 37.698L51.1373 37.698ZM51.1373 48.125C51.8434 48.125 52.4158 47.4884 52.4158 46.7031C52.4158 45.9178 51.8434 45.2812 51.1373 45.2812L18.7784 45.2812C18.0724 45.2812 17.5 45.9178 17.5 46.7031C17.5 47.4884 18.0724 48.125 18.7784 48.125L51.1373 48.125Z" fill="white" />
    </SVGWrapper>
  );
}

export default TvPlaylistActiveIcon;
